module.exports = __webpack_public_path__ + "img/News_Center_xs.fbbda825.png";